import React, { useEffect, ReactChildren, useState, useRef } from 'react';
import { Toast } from 'antd-mobile-v5';
import { withRouter, useHistory } from 'react-router-dom';
import styles from './index.module.scss';
import Header from '../components/header';
import InvitorInfo from './components/invitorInfo';
import PersonInfo from './components/personInfo';
import { ApiCore } from '../../api';
import { ToastHandler } from 'antd-mobile-v5/es/components/toast';
import Utils from '../../utils/utils'

const EPROConfirmInvit = (props: any) => {
    const api = new ApiCore()

    const [ disabled, setDisabled ] = useState(false)
    const [ projectName, setProjectName ] = useState('')
    const [ projectCode, setProjectCode ] = useState('')
    const [ subjectCode, setSubjectCode ] = useState('')
    const [ subjectDetail, setSubjectDetail] = useState<any>()
    const projectCodeRef = useRef('')
    const [ doctor, setDoctor ] = useState({
        code: '',
        name: '',
        avatUrl: '',
        hospitalName: ''
    })
    const [ person, setPerson ] = useState({
        id: '',
        name: '',
        phone: '',
        txr: '',
        xs: '',
        xb: '',
        jycb: '',
        jzcs: ''
    })

    useEffect(() => {
        document.title = '加入项目';
        loadInfo();
    }, [])

    useEffect(() => {
        return () => {
            Toast.clear()
        }
    })

    const handlePersonChange = (value: string, key: string) => {
        const newValue = {
            ...person
        }
        newValue[key] = value
        setPerson(newValue)
    }
    const validate = () => {
        let errMsg = '';
        if(subjectDetail?.editModel !== 1){
            // const phone = person.phone?.trim() || ''
            const name = person.name?.trim() || ''
            if (!name) {
                errMsg = '请输入姓名';
            } else if (name.length > 10) {
                errMsg = '姓名最多输入10个字符';
            // } else if (!(/^[\u4e00-\u9fa5a-zA-Z\s]+$/.test(name))) {
            } else if (!(/^[A-Z]+$/.test(name))) {
                errMsg = '姓名只能输入首字母大写';
            }

        }else if(subjectDetail?.editModel === 1){
            const xs = person.xs?.trim() || ''
  
           
            if(!person.txr){
                errMsg = '请选择本人还是家属';
            }
            if (!xs) {
                errMsg = '请输入姓名';
            } 

            if(!person.xb){
                errMsg = '请选择性别';
            }
            if(!person.jycb){
                errMsg = '请选择受教育程度';
            }
            if(!person.jzcs){
                errMsg = '请输入居住城市';
            }
        }
       
        // else if (!phone) {
        //     errMsg = '请输入手机号';
        // } else if (!(/^[1][3-9][0-9]{9}$/.test(phone))) {
        //     errMsg = '请输入正确的手机号';
        // }
        if (errMsg) {
            Toast.show({
                content: errMsg,
                icon: 'fail',
                duration: 2000
            })
            return false
        }
        return true
    }

    const gotoHome = () => {
        if(subjectDetail?.editModel === 1){
            Utils.isMiniProgram() ? (window as any).wx.miniProgram.reLaunch({
                url: '/pages/webview/webview?fromUrlFromH5=/epro/patient/welcome&toBeforeH5Url=1&from=EPRO_PT&projectCode=' + projectCodeRef.current
            }) : props.history.replace('/epro/patient/welcome?projectCode=' + projectCodeRef.current)
        }else{
            // props.history.replace('/epro/patient/home')
            Utils.isMiniProgram() ? (window as any).wx.miniProgram.reLaunch({
                url: '/pages/webview/webview?fromUrlFromH5=/epro/patient/home&toBeforeH5Url=1&from=EPRO_PT&projectCode=' + projectCodeRef.current
            }) : props.history.replace('/epro/patient/home?projectCode=' + projectCodeRef.current)
        }
     
       
    }

    let submiting = false

    const handleJoin = async () => {
        if (submiting) {
            return
        }
        submiting = true
        Toast.clear()
        let loadingToast: ToastHandler | null = null
        
        try {
            let randomCode = new URLSearchParams(props.location.search).get('randomCode') as string
            const validateResult = validate();
            if (!validateResult) {
                return
            }
            loadingToast = Toast.show({
                content: '正在提交...',
                icon: 'loading',
                duration: 0
            })
            const { code, message } = await api.sujectBinded({
                subjectCode: subjectCode,
                projectCode: projectCode,
                reportName: person.name.trim(),
                // reportUser: person.phone.trim(),
                reportUser: '',
                doctorName: doctor.name,
                doctorCode: doctor.code,
                randomCode: randomCode,
                txr: person.txr,
                xb: person.xb,
                xs: person.xs,
                jycb: person.jycb,
                jzcs: person.jzcs
            })
            submiting = false;
            loadingToast?.close();
            loadingToast = null;

            if (Number(code) === 0) {
                Toast.show({
                    content: '加入成功',
                    icon: 'success',
                    duration: 1000,
                    afterClose: () => {
                        gotoHome()
                    }
                })
                return
            } else {
                Toast.show({
                    content: message || '加入失败',
                    icon: 'fail',
                    duration: 2000
                })
            }
        } catch (error) {
            
        } finally {
            submiting = false
            loadingToast?.close()
        }
    
    }
    const loadInfo = async () => {
        try {
            let subjectCode = new URLSearchParams(props.location.search).get('subjectCode') as string
            let phone = new URLSearchParams(props.location.search).get('phone') as string
            // 获取项目信息
            const subjectRes  = await api.getSubjectdDetail({ id: subjectCode }) as any
            if (subjectRes?.code == 0) {
                setSubjectDetail(subjectRes?.data)
            }
            const { code, data, message } = await api.getSubjectBindingInfo({ subjectCode })
            projectCodeRef.current = data?.projectCode
            const codeNum = Number(code)
            setDisabled(codeNum !== 0)
            // 绑定状，0：未绑定，1：已绑定
            // 已经绑定，则跳转到首页
            if (data?.bindState === 1 && codeNum === 0) {
                gotoHome()
            }
            setProjectName(data?.projectName)
            setProjectCode(data?.projectCode)
            setSubjectCode(subjectCode)
            setDoctor({
                name: data?.doctorName,
                code: data?.doctorUser,
                hospitalName: data?.centerName,
                avatUrl: data?.url
            })
            setPerson({
                id: subjectCode,
                name: '',
                phone,
                txr: '',
                xs: '',
                xb: '',
                jycb: '',
                jzcs: ''
            })

            if (codeNum !== 0) {
                setTimeout(() => {
                    Toast.show({
                        content: message,
                        icon: 'fail',
                        duration: 2000
                    })
                }, 50)
            }

        } catch (error) {
            
        }
    }

    return (
        <div className={styles.epro_patient_confirm_invit}>
            <Header title='WELCOME' name={'欢迎加入' + (projectName || '')} secondName=''></Header>
            <div className={styles.invit_info}>
                <InvitorInfo name={doctor.name} avatUrl={doctor.avatUrl} hospitalName={doctor.hospitalName}></InvitorInfo>
                <PersonInfo id={person.id} name={person.name} phone={person.phone}  
                    txr={person.txr}  xs={person.xs} xb={person.xb}  jycb={person.jycb} jzcs={person.jzcs} 
                    editModel={subjectDetail?.editModel}  onChange={handlePersonChange}></PersonInfo>
            </div>
            <button className={styles.btnJoin} onClick={handleJoin} disabled={disabled}>确认加入</button>
        </div>
    )
}

export default EPROConfirmInvit;